import "./preferences.css";
import React from "react";
import { Button, Tabs, Tab } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { _t } from "../../app/i18n/i18n";
import { setPreference, togglePreference } from "./preferencesActions";
import { AppSettings } from "./parts/AppSettings";
import { postPreferences } from "./api/postPrefrences";
import { history } from "redux/configureStore";
import { ResearchInterests } from "./parts/ResearchInterests";
import { useIsRedesign } from "pages/redesign/preferences/redesignUtils";
import { switchDesign } from "./parts/switchDesign";

export function Preferences() {
  const preferences = useSelector((state) => state.preferences);
  const isRedesign = useIsRedesign();
  const dispatch = useDispatch();

  return (
    <section className={"bg-dark text-light " + (!isRedesign && " screen-height")}>
      <article className="user-profile py-4 px-2 mb-0 h-100 maxw-600 rounded-0">
        <Tabs defaultActiveKey="researchInterests">
          <Tab eventKey="researchInterests" title="Research Interests" className="pt-3">
            <ResearchInterests handleClick={(tag, preference) => handlePreferenceClick(tag, preference, dispatch)} />
          </Tab>

          <Tab eventKey="appSettings" title="App Settings" className="pt-3">
            <AppSettings handleClick={(tag, preference) => handlePreferenceClick(tag, preference, dispatch)} />
          </Tab>
        </Tabs>

        {!isRedesign && (
          <>
            <Button className="d-block ml-auto mr-0 mb-2" onClick={() => handleDoneClick(preferences)}>
              {_t("Save")}
            </Button>

            <p className="text-center">
              {_t("You can change your preferences later in the preferences option from the menu.")}
            </p>
          </>
        )}
      </article>
    </section>
  );
}

const handlePreferenceClick = (tag, preference, dispatch) => {
  if (preference.noMultiSelect) {
    dispatch(setPreference({ key: preference.id, value: tag }));
  } else {
    dispatch(togglePreference({ key: preference.id, value: tag, preference }));
  }

  if (preference.id === "grp-redesign") {
    switchDesign(tag);
  }
};

const handleDoneClick = (preferences) => {
  postPreferences(preferences);
  history.goBack();
};
